import { css } from 'styled-components';
import { ProgressProps, StepperProps } from './models';

export const Stepper = css<StepperProps>(({ theme }) => {
  return css`
    > .steps-wrapper {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 4px;
      width: 100%;

      > .step-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        gap: 4px;

        > .title {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 21px;
          color: #3156ff;
          margin: 0;
          padding: 0;

          @media only screen and (max-width: 480px) {
            display: none;
          }

          @media only screen and (max-width: 768px) {
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }
  `;
});

export const Progress = css<ProgressProps>(({ theme, progress }) => {
  return css`
    width: 100%;
    border-radius: 50px;
    height: 4px;
    background: linear-gradient(to right, #3156ff ${progress}%, #f2f4f7 ${progress}%);
  `;
});
